import { render, staticRenderFns } from "./PaymentAuthorization.vue?vue&type=template&id=5ec4b99e"
import script from "./PaymentAuthorization.vue?vue&type=script&lang=js"
export * from "./PaymentAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports